module.exports = __webpack_public_path__ + "img/china-southern.b675875f.webp";